<template>
  <div>
    <div class="top-bg">
      <img src="@/assets/images/bg-up-contact.svg" alt="bg-up" />
    </div>

    <div id="contact">
      <h2>Get In Touch</h2>
      <p>
        If you have any business inquiries, let's get in touch.
      </p>
      <br />
      <a class="btn" href="mailto:smileydoodle.official@gmail.com"
        >CONTACT ME</a
      >
    </div>

    <div class="down-bg">
      <img src="@/assets/images/bg-down-contact.svg" alt="bg-down" />
    </div>
  </div>
</template>

<script>
export default {
  name: "GetInTouch",
};
</script>

<style>
#contact {
  background-color: #01766f;
  color: #fff;
  padding: 80px 0 20px;
}
#contact p {
  width: 40%;
  margin: 0 auto;
  padding-top: 1rem;
  font-size: 1.2rem;
}
.btn {
  border-radius: 10px;
  background: #fff;
  box-shadow: 3px 8px 9px #085561;
  color: #6c757d;
  padding: 10px;
  text-decoration: none;
  display: block;
  width: 200px;
  margin: 2rem auto;
}
.btn:hover {
  background-color: #f3a822;
  transition: all 0.5s ease-in;
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  #contact {
    padding-top: 40px;
  }
  #contact p {
    font-size: 0.9rem;
    width: 65%;
  }
  .btn {
    font-size: 0.8rem;
    width: 150px;
    margin: 1rem auto;
  }
}
</style>
